import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";

import { DEFAULT_ORANGE } from "../../../../_globalStore/redux/reducers/Theme/themeConstants";

export const RootContainer = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "showDeadline" && prop !== "isDeadlineLate",
})<{ showDeadline: boolean; isDeadlineLate: boolean }>(
  {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    visibility: "hidden",
    opacity: 0,
    transition: "all .4s ease",

    "& > p": {
      fontSize: ".8em",
      cursor: "default",
    },

    "& > button": {
      fontSize: ".9em",
      padding: 10,
    },
  },
  ({ showDeadline, isDeadlineLate, theme }) => ({
    ...(showDeadline && {
      visibility: "visible",
      opacity: 1,
    }),
    ...(isDeadlineLate && {
      color: theme.palette.warning.main,
    }),
  })
);
